<ul *ngIf="hints && hints.length" class="mat-tooltip" [@inOutAnimation]>
    <li *ngFor="let hint of hints">
        <span class="name">{{ hint.name }}</span>
        <span class="text">{{ hint.text }}</span>
    </li>
</ul>